import axios from 'axios';

export const ZipcodeAPI = {
    fetchAddress: (zipcode) => {
        return axios.get(`https://cep.wdna.com.br/zipcode/search/${zipcode}`);
    },
};
